/**
 * The purpose of this file is...
 *  - give overview of all the mutations types
 *  - ensure no duplicates
 *  - allow us to change them in one place
 */

// Auth
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'REGISTER_FAILURE'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const SET_USER = 'SET_USER'
export const TOKEN_INVALID = 'TOKEN_INVALID'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'

// Page
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
export const SET_PAGE_DESCRIPTION = 'SET_PAGE_DESCRIPTION'
export const SET_PAGE_KEYWORDS = 'SET_PAGE_KEYWORDS'
export const OPEN_SIDEBAR = 'OPEN_SIDEBAR'
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR'
export const SHOW_PUBLIC_ELEMS = 'SHOW_PUBLIC_ELEMS'
export const HIDE_PUBLIC_ELEMS = 'HIDE_PUBLIC_ELEMS'
export const SET_AD_AREA = 'SET_AD_AREA'
export const CONTACT_US_SUCCESS = 'CONTACT_US_SUCCESS'

// Subjects
export const RETRIEVE_SUBJECTS_SUCCESS = 'RETRIEVE_SUBJECTS_SUCCESS'
export const CREATE_SUBJECT_SUCCESS = 'CREATE_SUBJECT_SUCCESS'
export const DELETE_SUBJECT_SUCCESS = 'DELETE_SUBJECT_SUCCESS'

// Chapters
export const CREATE_CHAPTER_SUCCESS = 'CREATE_CHAPTER_SUCCESS'
export const UPDATE_CHAPTER_SUCCESS = 'UPDATE_CHAPTER_SUCCESS'
export const DELETE_CHAPTER_SUCCESS = 'DELETE_CHAPTER_SUCCESS'

// Lecture Notes
export const CREATE_LECTURE_NOTE_SUCCESS = 'CREATE_LECTURE_NOTE_SUCCESS'
export const RETRIEVE_LECTURE_NOTES_SUCCESS = 'RETRIEVE_LECTURE_NOTES_SUCCESS'
export const UPDATE_LECTURE_NOTE_HTML = 'UPDATE_LECTURE_NOTE_HTML'
export const UPDATE_LECTURE_NOTE_SUCCESS = 'UPDATE_LECTURE_NOTE_SUCCESS'

// Ads
export const CREATE_AD_SUCCESS = 'CREATE_AD_SUCCESS'
export const UPDATE_AD_SUCCESS = 'UPDATE_AD_SUCCESS'
export const DELETE_AD_SUCCESS = 'DELETE_AD_SUCCESS'

// Courses
export const CREATE_COURSE_SUCCESS = 'CREATE_COURSE_SUCCESS'
export const UPDATE_COURSE_SUCCESS = 'UPDATE_COURSE_SUCCESS'
export const DELETE_COURSE_SUCCESS = 'DELETE_COURSE_SUCCESS'

// Micronote Exporter
export const EXPORT_MICRONOTES_SUCCESS = 'EXPORT_MICRONOTES_SUCCESS'
export const ADD_MICRONOTES_TO_EXPORT = 'ADD_CHAPTERS_TO_EXPORT'
export const REMOVE_MICRONOTES_FROM_EXPORT = 'REMOVE_CHAPTERS_FROM_EXPORT'
export const SET_INCLUDE_INACTIVE_MICRONOTES = 'SET_INCLUDE_INACTIVE_MICRONOTES'

// Micronote Exporter
export const IMPORT_MICRONOTES_SUCCESS = 'IMPORT_MICRONOTES_SUCCESS'

// Notifications
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
export const REMOVE_ALL_NOTIFICATIONS = 'REMOVE_ALL_NOTIFICATIONS'
export const REMOVE_NOTIFICATION_WITH_ITEM = 'REMOVE_NOTIFICATION_WITH_ITEM'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js